import { animationFrameScheduler, fromEvent, interval } from 'rxjs'
import { map, withLatestFrom } from 'rxjs/operators'

import { initTransform, tiltSpeed } from './constants'
import { createRoomMovement } from './roomHelpers'

type RotationValues = { x: number | null; y: number | null }

export const roomTiltLogic = () => {
  const win = {
    width: window.innerWidth,
    height: window.innerHeight,
  }

  const mapToMousePos = (event: MouseEvent) => {
    const noMousePos = {
      x: null,
      y: null,
    }

    if (!event) {
      return noMousePos
    }

    if (event.pageX || event.pageY) {
      return {
        x: event.pageX,
        y: event.pageY,
      }
    }

    return noMousePos
  }

  const mapToRotationValues = ({ x, y }: RotationValues) => {
    if (x === null || y === null) {
      return {
        rotX: 0,
        rotY: 0,
      }
    }
    return {
      rotX: initTransform.rotateX - (((2 * tiltSpeed.rotateX) / win.height) * y - tiltSpeed.rotateX),
      rotY: initTransform.rotateY - (((2 * tiltSpeed.rotateY) / win.width) * x - tiltSpeed.rotateY),
    }
  }

  const mapToTransform = ({ rotX = 0, rotY = 0 }) => ({
    roomMovement: createRoomMovement({ rotateX: rotX, rotateY: rotY }),
    rotateValues: { rotX, rotY },
  })

  const animationFrame$ = interval(0, animationFrameScheduler)
  const move$ = fromEvent<MouseEvent>(document.documentElement, 'mousemove')

  const smoothMove$ = animationFrame$.pipe(
    withLatestFrom(move$, (frame, move) => move),
    map(mapToMousePos),
    // distinctUntilChanged(isSame),
    map(mapToRotationValues),
    map(mapToTransform),
  )

  return {
    smoothMove$,
  }
}
